import type { MutationTuple } from '@apollo/client';
import type {
  EndCurrentParentFrameMutation,
  EndCurrentParentFrameMutationVariables
} from '@aurora/shared-generated/types/graphql-types';
import ParentFrameSupplier from '@aurora/shared-utils/analytics/ParentFrameSupplier';
import { v4 as uuid } from 'uuid';
import useMutationWithTracing from '../../useMutationWithTracing';
import frameEndMutation from './AnalyticsFrameEnd.mutation.graphql';

/**
 * `useFrameEnd` calls the FrameEnd Event for Parent frame UUID.
 *
 * @author Madhusudhana RK
 */
export default function useFrameEnd(): MutationTuple<
  EndCurrentParentFrameMutation,
  EndCurrentParentFrameMutationVariables
> {
  const parentFrameId = ParentFrameSupplier.getParentFrameId();
  return useMutationWithTracing<
    EndCurrentParentFrameMutation,
    EndCurrentParentFrameMutationVariables
  >(module, frameEndMutation, {
    variables: { uuid: parentFrameId },
    onCompleted: () => {
      ParentFrameSupplier.setParentFrameId(uuid());
    }
  });
}
